import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20",
  fill: "none",
  viewBox: "3486 391 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3488 411q-.825 0-1.412-.588A1.92 1.92 0 0 1 3486 409v-14q0-.825.588-1.412.587-.588 1.412-.588h1v-2h2v2h8v-2h2v2h1q.824 0 1.413.588.588.587.587 1.412v14q0 .825-.587 1.412A1.93 1.93 0 0 1 3502 411zm0-2h14v-10h-14zm0-12h14v-2h-14zm0 0v-2z",
      class: "fills",
      style: {"fill":"#1f7eff","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }